import { gql } from '@apollo/client'
import { CORE_COACHING_KIND_FIELDS } from './coachingKind'

export const CORE_USER_FIELDS = gql`
  ${CORE_COACHING_KIND_FIELDS}
  fragment CoreUserFields on User {
    id
    email
    fullName
    firstName
    lastName
    dateOfBirth
    phoneNumber
    avatar
    timeZone
    intercomDigest
    role
    mfaEnabled
    surveyLinks {
      id
      finished
      startedAt
      state
      survey {
        header
        kind
        research
      }
    }
    uiStates {
      name
      value
      createdAt
    }
    lastCoreSubscription {
      id
      subscribedAt
    }
    lastOccurredCoachingAppointment {
      id
      kind
      providers {
        coach {
          fullName
          photo
          coachId
        }
      }
      lastState {
        createdAt
      }
      coachRating
    }
    features
    followupSchedulingAvailable
    signUpSource
    uhcMember {
      id
      uhcId
      appAccessBlocked
    }
    primaryCoachingKind {
      ...CoreCoachingKindFields
    }
    referralPartner {
      key
    }
  }
`
